<div class="container-price flex flex-col">
  <div class="discount flex flex-row items-center">
    <span *ngIf="isDiscount" class="small-text line-middle">
      {{ getPrice().previousPrice | currency }}
    </span>
    <div *ngIf="isDiscount" class="discount-label">
      {{ discountLabel }}
    </div>
  </div>

  <span class="finalPrice mr-5">
    <span *ngIf="product.hasVariant || product.isCustom">Desde</span>
    {{ getPrice().currentPrice | currency }}
  </span>
</div>
